import { createFileRoute } from '@tanstack/react-router';

import StoreAnalyticsPage from '@/components/store/analytics/Page';

export const Route = createFileRoute('/store/analytics')({
	component: StoreAnalyticsPage,
});
